import { z } from "zod";

export const nodeSlotPathSegmentSchema = z
  .object({
    parent: z.tuple([z.string(), z.number()]),
    name: z.string(),
    index: z.number().optional(), // this doubles as telling us it is a multi-value
  })
  .readonly();

export type NodeSlotPathSegment = z.infer<typeof nodeSlotPathSegmentSchema>;

export const nodeSlotPathSchema = z.array(nodeSlotPathSegmentSchema);

export type NodeSlotPath = z.infer<typeof nodeSlotPathSchema>;
